import axios from 'axios';

const spanLinksSelector = 'jlink';
const jsonLinks = '/upload/seo/hidden-links.json';
let windowOpenerAccess = true;

const addSpanAnchors = element => {
    if (element && !(element instanceof HTMLElement)) throw new Error('argument is to be html element');
    const domEl = element ? element : document;
    const spanAnchors = domEl.querySelectorAll('span[class*="' + spanLinksSelector + '"]');
    if (!spanAnchors.length) return;

    [...spanAnchors].map(anch => {
        const anchorHref = anch.getAttribute('data-href');
        if (!anchorHref) return anch.classList.remove(spanLinksSelector);
        const anchorTarget = anch.getAttribute('data-target') ? anch.getAttribute('data-target') : '_self';
        const anchorRels = anch.getAttribute('rel')?.split(' ');
        if (anchorRels)
            for (const rel of anchorRels) {
                if (rel === 'noopener') {
                    windowOpenerAccess = false;
                    break;
                }
            }
        anch.classList.remove(spanLinksSelector);
        anch.addEventListener('click', () => {
            windowOpenerAccess ?
                window.open(anchorHref, anchorTarget) :
                window.open(anchorHref, anchorTarget, ['noopener,noreferrer']).opener = null;
        });
    });
};

const fetchHiddenLinks = async () => {
    let hiddenLinks = [];
    await axios.get(jsonLinks, {headers: {'Accept': 'application/vnd.api+json'}})
        .then(response => {
            const data = response.data;
            if (!Array.isArray(data)) throw new Error('hidden-links is to be a correct arr');
            hiddenLinks = data;
        })
        .catch(err => {
            if (err.response?.status === 404) {
                throw new Error('no hidden-links found');
            } else {
                console.error(err.message) // eslint-disable-line
            }
        })
    return hiddenLinks;
};

const detectHiddenLink = (link, hiddenLinks) => {
    if (!hiddenLinks?.length || !link) return false;
    return hiddenLinks?.some(el => el === link.split('#')[0]);
};

export {
    addSpanAnchors,
    fetchHiddenLinks,
    detectHiddenLink
};
